<!-- loader -->
<div class="loader_session" *ngIf='loaderdata'>
  <div class="loader-4"><span></span>
  </div>
</div>

<!-- top nav -->
<div class="top-navbar">
  <div class="topbar-header">
    <div class="navheader-items">
      <div class="login-session">
        <ng-template [ngIf]="!getName">
          <a (click)="regelement()">JOIN US</a> <span class="spanitem">|</span>
          <a (click)="loginelement()">LOGIN</a>
        </ng-template>
        <ng-template [ngIf]="getName">
          <a routerLink="/userpage" style="text-transform: uppercase;">{{getName}}</a> <span class="spanitem">|</span>
          <a (click)="logout()">LOGOUT</a>
        </ng-template>
      </div>
      <span class="orelement home-elemnt">|</span>
      <div class="home-item">
        <a routerLink="/"><img src="assets/image/Group 269.svg" alt="" srcset="" /></a>
      </div>
      <span class="orelement social-element">|</span>
      <!-- <i (click)="click()" class="fa fa-envelope-o classenv" aria-hidden="true"></i> -->

      <a [routerLink]="['/']" fragment="contactus" (click)="click()"><i class="fa fa-envelope-o classenv"
          aria-hidden="true"></i></a>

      <a href="https://www.facebook.com/groups/phonograph/" style="margin:0 0.5rem;"><img
          src="assets/image/Group 255.svg" alt="" srcset=""></a>
      <a href="https://www.instagram.com/antiquephonosociety/?utm_medium=copy_link" style="margin:0 0.25rem;"><img
          src="assets/image/Group 213.svg" alt="" srcset="" /></a>

      <!-- <a href="#"  style="margin:0 0.25rem;"
          ><img src="assets/image/Group 217.svg" alt="" srcset=""
        /></a>
        <a href="#"  style="margin:0 0.25rem;"
          ><img src="assets/image/Group 256.svg" alt="" srcset="" />
        </a> -->

    </div>
  </div>
  <div class="nav-element">
    <div class="logo-item">
      <a href="/">

        <img src="assets/image/logo.png" alt="" srcset="" />
      </a>
    </div>
    <div class="resp-nav">
      <div class="container-fluid">
        <div class="row">
          <div class="col-6">
            <div class="resp-logo">
              <a routerLink="/"> <img src="assets/image/logo.png" alt="" srcset="" /></a>
            </div>
          </div>
          <div class="col-6">
            <div class="nav-responcive-icon">
              <span class="resp-nav-item">
                <i class="fa fa-bars" aria-hidden="true"></i></span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="navbar-items">
      <div class="dropdown-nav">
        <span class="topicon"></span>
        <a class="">INTRODUCTORY ARTICLES
          <i class="fa fa-angle-down" aria-hidden="true"></i></a>
        <div class="drop-element">
          <a routerLink="collection/1">COLLECTING BASICS</a>
          <!-- <a routerLink="ereader/1">E-Reader</a> -->
          <a href="https://apsblobdeve.blob.core.windows.net/aps-website-files/APSPriceGuide_Public.pdf"
            target="_blank">PRICE GUIDE (PUBLIC)</a>
        </div>

      </div>
      <!-- <div class="navitem">
        <span class="topicon"></span>
        <a routerLink="/catalogs">RESOURCE CATALOGS</a>
      </div> -->
      <div class="dropdown-nav">
        <span class="topicon"></span>
        <a class="">MEMBER RESOURCES<i class="fa fa-angle-down" aria-hidden="true"></i></a>
        <code>
        </code>
        <div class="drop-element">
          <!-- <a routerLink="priceGuide">PRICE GUIDE</a> -->
          <a routerLink="priceGuide" target="_blank">PRICE GUIDE</a>

          <a routerLink="category/1">LIBRARY CATALOG</a>
          <a routerLink="catalogs">LIBRARY SEARCH</a>
          <li class="menu">eJOURNAL<span class="expand">&raquo;</span>
            <ul class="submenu">

              <!-- {{item.ereader_title}} -->
              <li *ngFor="let item of book.data">


                <a *ngIf="userLoggedIn();else notloggedin" (click)=" hoverClick()" href="{{item.ereader_url}}"
                  target="_blank">{{item.ereader_title}}</a>
                <ng-template #notloggedin> <a (click)=" hoverClick()">{{item.ereader_title}}</a></ng-template>
              </li>
              <li><a routerLink="ereader/1">View More</a></li>
            </ul>
          </li>

          <!-- <a routerLink="catalogs">LIBRARY</a> -->
        </div>
      </div>
      <div class="navitem">
        <span class="topicon"></span>
        <a target="_blank" href="https://forum.antiquephono.org/">APS FORUM</a>
      </div>
      <div class="dropdown-nav">
        <span class="topicon"></span>
        <a routerLink="/event/future/1">EVENTS</a>
        <!-- <i class="fa fa-angle-down" aria-hidden="true"></i>
        <div class="drop-element">
          <a routerLink="/event/future/1">FUTURE EVENTS</a>
          <a routerLink="/event/past/1">PAST EVENTS</a>
        </div> -->
      </div>
      <!-- <div class="dropdown-nav">
        <span class="topicon"></span>
        <a class="">SHOP <i class="fa fa-angle-down" aria-hidden="true"></i></a>
        <div class="drop-element">
          <a href="/onlineshop/1">ONLINE SHOP</a>
        </div>
      </div> -->
      <div class="navitem">
        <span class="topicon"></span>
        <a routerLink="/onlineshop/1">ONLINE SHOP</a>
      </div>

      <div class="navitem">
        <span class="topicon"></span>
        <a routerLink="/donation">DONATIONS</a>
      </div>
      <!-- <div class="dropdown-nav">
        <span class="topicon"></span>
        <a class=""
          >PRICE GUIDE <i class="fa fa-angle-down" aria-hidden="true"></i
        ></a>
        <div class="drop-element">
          <a href="#">MEMBERS</a>
          <a href="#">PUBLIC</a>
        </div>
      </div>

      <div class="navitem">
        <span class="topicon"></span>
        <a href="#">CONTACT US</a>
      </div> -->
    </div>
  </div>
</div>

<!-- Login -->
<div class="login-section" (click)="closingdiv()">
  <div class="login" id="loginbox">
    <div class="log-header">
      <p>LOGIN</p> <span class="close-btn"><i (click)="closebtnlogin()" class="fa fa-times"
          aria-hidden="true"></i></span>
    </div>
    <div class="log-form">
      <form #userlogindata="ngForm" (ngSubmit)="onClickSubmitlogin(userlogindata.value)">


        <div class="form-group">
          <input type="text" class="form-control" placeholder="USER NAME" [ngModel] required name="username"
            #username=ngModel autocomplete="off" />
          <div class="alertbox-err" *ngIf="username.touched && username.invalid">
            Username Required
          </div>
        </div>
        <div class="form-group">
          <input type="password" class="form-control" placeholder="PASSWORD" [ngModel] required name="password"
            #password=ngModel />
          <div class="alertbox-err" *ngIf="password.touched && password.invalid">
            password Required
          </div>
        </div>
        <div class="log-forgot">
          <a routerLink="/resetpassword" (click)="closebtnlogin()">Forgot password?</a>
        </div>
        <!-- <div class="log-forgot">
          <input type="checkbox" /> Remember me 
        </div> -->
        <div class="btn-login">
          <input type="submit" class="login-btn" value="LOGIN">
        </div>
        <div class="reg-direct">
          <p>New to antiquephono.org? <a [routerLink]="['/login']" [queryParams]="{'Login': 'signup'}">Register Now</a>
          </p>
        </div>
      </form>
    </div>
    <div class="login-condition">
      <p>By continuing, you agree to our <a routerLink="/privacy" target="_blank"> Terms & Conditions </a></p>
    </div>
  </div>
</div>

<!-- reg -->
<!-- <div class="reg-section" (click)="closingdivreg()">
  <div class="register" id="loginbox">
    <div class="headerreg">
      <p>REGISTER</p>
      <span class="close-btn"><i  (click)="closebtnreg()" class="fa fa-times" aria-hidden="true"></i></span>
    </div>
    <form #userlogin="ngForm" (ngSubmit)="onClickSubmitnew(userlogin.value)">
      <div class="row">
        <div class="col-lg-8">
          <div class="row">
            <div class="col-lg-4">
              <div class="reg-membership">
                <div class="heading">
              
                  <h4>  {{listUSA?.planyear}}</h4>
                  <p>  {{listUSA?.name}}</p>
                </div>
                
          
                <div class="reg-mbr-year">

                  
                  <select
                    class="form-select mb-2"
                    aria-label=".form-select-lg example"
                    (change)="onChangesusa($event.target.value)"
                    name="Usaplanyear"
                    [ngModel]
                  >
                  <option [ngValue]="null" [disabled]="true" [selected]='true'>Select period</option>
                    <ng-template ngFor let-usplan [ngForOf]="usaplans[0]">
                    <option  value="{{usplan?.plan_id}}" >{{usplan?.planename}}</option>
                    </ng-template>
                   
                  </select>
                </div>
                <div class="rate">
                  <h1  id="usa_rate">${{rate_usa}}</h1>
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value="usa"
                     
                      id="flexCheckDefault"
                      name="Usaplan"
                      (change)="checkplanes($event.target.value)"
                      [ngModel]=usachecked
                    />
                    <label class="form-check-label" for="flexCheckDefault">
                    </label>
                  </div>
                <p>Select Here</p>
                </div>
              </div>
              <div class="donation">
                <select class="form-select fullsize mb-3" aria-label="" name="DonationUsa" [ngModel]>
                  <option [ngValue]="null" [disabled]="true" [selected]='true'>Donation</option>
                  <option value="0">$0</option>
                  <option value="10">$10</option>
                  <option value="25">$25</option>
                  <option value="50">$50</option>
                  <option value="100">$100</option>
                </select>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="reg-membership">
                <div class="heading">
                  <h4>{{listCanada?.planyear}}</h4>
                  <p>{{listCanada?.name}}</p>
                </div>
                <div class="reg-mbr-year">
                  <select
                    class="form-select mb-2"
                    aria-label=".form-select-lg example"
                    name="Canadaplanyear"
                    (change)="onChangescanada($event.target.value)"
                    [ngModel]
                  >
                  <option [ngValue]="null" [disabled]="true" [selected]='true'>Select period</option>
                    <ng-template ngFor let-usplan [ngForOf]="canadaplans[0]">
                      <option  value="{{usplan?.plan_id}}" >{{usplan?.planename}}</option>
                      </ng-template>
                  </select>
                </div>
                <div class="rate">
                  <h1 class=""  id="canada_rate">${{rate_canada}}</h1>
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value="canada"
                      id="flexCheckDefault"
                      name="Canadaplan"
                      
                      (change)="checkplanes($event.target.value)"
                      [ngModel]=canadachecked
                    />
                    <label class="form-check-label" for="flexCheckDefault">
                    </label>
                  </div>
                  <p>Select Here</p>
                </div>
              </div>
              <div class="donation">
                <select class="form-select fullsize mb-3" aria-label=""  [ngModel] name="DonationCanada" >
                  <option [ngValue]="null" [disabled]="true"  [selected]='true'>Donation</option>
                  <option value="0">$0</option>
                  <option value="10">$10</option>
                  <option value="25">$25</option>
                  <option value="50">$50</option>
                  <option value="100">$100</option>
                </select>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="reg-membership">
                <div class="heading">
                  <h4>{{listOthers?.planyear}}</h4>
                  <p>{{listOthers?.name}}</p>
                </div>
                <div class="reg-mbr-year">
                  <select
                    class="form-select mb-2"
                    aria-label=".form-select-lg example"
                    name="otherplanyear"
                    [ngModel]
                    (change)="onChangesothers($event.target.value)"
                  >
                  <option [ngValue]="null" [disabled]="true" [selected]='true'>Select period</option>
                    <ng-template ngFor let-usplan [ngForOf]="otherPlans[0]">
                      <option  value="{{usplan?.plan_id}}" >{{usplan?.planename}}</option>
                      </ng-template>
                  </select>
                </div>
                <div class="rate">
                  <h1 class="rates" id="rest_rate">${{rate_other}}</h1>
                 
                  <div class="form-check">
                   
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value="other"
                      id="flexCheckDefault"
                      name="Otherplan"
                      (change)="checkplanes($event.target.value)"
                      [ngModel]=otherchecked
                      required
                     
                    />
                 <br>
    
                  
                  </div>
                  <p>Select Here</p>
                </div>
              </div>
              <div class="donation">
                <select class="form-select fullsize mb-3" aria-label="" [ngModel] name="DonationOther" >
                  <option [ngValue]="null" [disabled]="true" [selected]='true'>Donation</option>
                  <option value="0">$0</option>
                  <option value="10">$10</option>
                  <option value="25">$25</option>
                  <option value="50">$50</option>
                  <option value="100">$100</option>
                </select>
              </div>
            </div>
          </div>
        </div>
        <div class="col-lg-4">
          <div class="reg-form">

        
            <div class="form-group">
              <input
                type="text"
                name="username"
                class="form-control"
                [ngModel]
                placeholder="USER NAME"
                required
                #usernames="ngModel"
              />
              <div class="alertbox-err" *ngIf="usernames.touched && usernames.invalid">
                Username Required
            </div>
            </div>
            
            <div class="form-group">
              <input
                type="password"
                class="form-control"
                name="password"
                placeholder="PASSWORD"
                [ngModel]
                required
                #passwords="ngModel"
              />
              <div class="alertbox-err" *ngIf="passwords.touched && passwords.invalid">
                Password Required
            </div>
            </div>
            <div class="form-group">
              <input
                type="password"
                name="confrm_password"
                class="form-control"
                placeholder="CONFIRM PASSWORD"
                [ngModel]
                required
                #confirmPassword="ngModel"

              />
              <div class="alertbox-err" *ngIf="confirmPassword.touched && confirmPassword.invalid">
                Confirm Password Required
            </div>
            <div class="alertbox-err" *ngIf="passwordErr">
              {{passwordErr}}
          </div>
             
            </div>
          </div>
        </div>
      </div>
      <div class="signup">
        <button (click)="closedev()" 
        class="reg-btn">
          SIGN UP
        </button>
      </div>
    </form>
    <div class="log-direct">
      <p>Already registered? <a [routerLink]="['/login']" [queryParams]="{'Login': 'login'}" >Login Here</a></p>
    </div>
    <div class="reg-condition">
      <p>By continuing, you agree to our <a routerLink="/privacy" target="_blank"> Terms & Conditions </a></p>
    </div>
  </div>
</div> -->




<div class="reg-section" (click)="closingdivreg()">
  <div class="register" id="loginbox">
    <div class="headerreg">
      <p>REGISTER</p>
      <span class="close-btn"><i (click)="closebtnreg()" class="fa fa-times" aria-hidden="true"></i></span>
    </div>
    <!-- <form #userlogin="ngForm" (ngSubmit)="onClickSubmitnew(userlogin.value)">
      <div class="row">
        <div class="col-lg-8">
          <div class="row">
            <div class="col-lg-4">
              <div class="reg-membership">
                <div class="heading">
              
                  <h4>  {{listUSA?.planyear}}</h4>
                  <p>  {{listUSA?.name}}</p>
                </div>
                
          
                <div class="reg-mbr-year">

                  
                  <select
                    class="form-select mb-2"
                    aria-label=".form-select-lg example"
                    (change)="onChangesusa($event.target.value)"
                    name="Usaplanyear"
                    [ngModel]
                  >
                  <option [ngValue]="null" [disabled]="true" [selected]='true'>Select period</option>
                    <ng-template ngFor let-usplan [ngForOf]="usaplans[0]">
                    <option  value="{{usplan?.plan_id}}" >{{usplan?.planename}}</option>
                    </ng-template>
                   
                  </select>
                </div>
                <div class="rate">
                  <h1  id="usa_rate">${{rate_usa}}</h1>
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value="usa"
                     
                      id="flexCheckDefault"
                      name="Usaplan"
                      (change)="checkplanes($event.target.value)"
                      [ngModel]=usachecked
                    />
                    <label class="form-check-label" for="flexCheckDefault">
                    </label>
                  </div>
                <p>Select Here</p>
                </div>
              </div>
              <div class="donation">
                <select class="form-select fullsize mb-3" aria-label="" name="DonationUsa" [ngModel]>
                  <option [ngValue]="null" [disabled]="true" [selected]='true'>Donation</option>
                  <option value="0">$0</option>
                  <option value="10">$10</option>
                  <option value="25">$25</option>
                  <option value="50">$50</option>
                  <option value="100">$100</option>
                </select>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="reg-membership">
                <div class="heading">
                  <h4>{{listCanada?.planyear}}</h4>
                  <p>{{listCanada?.name}}</p>
                </div>
                <div class="reg-mbr-year">
                  <select
                    class="form-select mb-2"
                    aria-label=".form-select-lg example"
                    name="Canadaplanyear"
                    (change)="onChangescanada($event.target.value)"
                    [ngModel]
                  >
                  <option [ngValue]="null" [disabled]="true" [selected]='true'>Select period</option>
                    <ng-template ngFor let-usplan [ngForOf]="canadaplans[0]">
                      <option  value="{{usplan?.plan_id}}" >{{usplan?.planename}}</option>
                      </ng-template>
                  </select>
                </div>
                <div class="rate">
                  <h1 class=""  id="canada_rate">${{rate_canada}}</h1>
                  <div class="form-check">
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value="canada"
                      id="flexCheckDefault"
                      name="Canadaplan"
                      
                      (change)="checkplanes($event.target.value)"
                      [ngModel]=canadachecked
                    />
                    <label class="form-check-label" for="flexCheckDefault">
                    </label>
                  </div>
                  <p>Select Here</p>
                </div>
              </div>
              <div class="donation">
                <select class="form-select fullsize mb-3" aria-label=""  [ngModel] name="DonationCanada" >
                  <option [ngValue]="null" [disabled]="true"  [selected]='true'>Donation</option>
                  <option value="0">$0</option>
                  <option value="10">$10</option>
                  <option value="25">$25</option>
                  <option value="50">$50</option>
                  <option value="100">$100</option>
                </select>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="reg-membership">
                <div class="heading">
                  <h4>{{listOthers?.planyear}}</h4>
                  <p>{{listOthers?.name}}</p>
                </div>
                <div class="reg-mbr-year">
                  <select
                    class="form-select mb-2"
                    aria-label=".form-select-lg example"
                    name="otherplanyear"
                    [ngModel]
                    (change)="onChangesothers($event.target.value)"
                  >
                  <option [ngValue]="null" [disabled]="true" [selected]='true'>Select period</option>
                    <ng-template ngFor let-usplan [ngForOf]="otherPlans[0]">
                      <option  value="{{usplan?.plan_id}}" >{{usplan?.planename}}</option>
                      </ng-template>
                  </select>
                </div>
                <div class="rate">
                  <h1 class="rates" id="rest_rate">${{rate_other}}</h1>
                 
                  <div class="form-check">
                   
                    <input
                      class="form-check-input"
                      type="checkbox"
                      value="other"
                      id="flexCheckDefault"
                      name="Otherplan"
                      (change)="checkplanes($event.target.value)"
                      [ngModel]=otherchecked
                      required
                     
                    />
                 <br>
    
                  
                  </div>
                  <p>Select Here</p>
                </div>
              </div>
              <div class="donation">
                <select class="form-select fullsize mb-3" aria-label="" [ngModel] name="DonationOther" >
                  <option [ngValue]="null" [disabled]="true" [selected]='true'>Donation</option>
                  <option value="0">$0</option>
                  <option value="10">$10</option>
                  <option value="25">$25</option>
                  <option value="50">$50</option>
                  <option value="100">$100</option>
                </select>
              </div>
            </div>


          </div>
        </div>
        <div class="col-lg-4">
          <div class="reg-form">

        
            <div class="form-group">
              <input
                type="text"
                name="username"
                class="form-control"
                [ngModel]
                placeholder="USER NAME"
                required
                #usernames="ngModel"
              />
              <div class="alertbox-err" *ngIf="usernames.touched && usernames.invalid">
                Username Required
            </div>
            </div>
            
            <div class="form-group">
              <input
                type="password"
                class="form-control"
                name="password"
                placeholder="PASSWORD"
                [ngModel]
                required
                #passwords="ngModel"
              />
              <div class="alertbox-err" *ngIf="passwords.touched && passwords.invalid">
                Password Required
            </div>
            </div>
            <div class="form-group">
              <input
                type="password"
                name="confrm_password"
                class="form-control"
                placeholder="CONFIRM PASSWORD"
                [ngModel]
                required
                #confirmPassword="ngModel"

              />
              <div class="alertbox-err" *ngIf="confirmPassword.touched && confirmPassword.invalid">
                Confirm Password Required
            </div>
            <div class="alertbox-err" *ngIf="passwordErr">
              {{passwordErr}}
          </div>
             
            </div>
          </div>
        </div>
      </div>
      <div class="signup">
        <button (click)="closedev()" 
        class="reg-btn">
          SIGN UP
        </button>
      </div>
    </form> -->

    <form [formGroup]="form" (ngSubmit)="onClickSubmitnew()">
      <div class="row">
        <div class="col-lg-8">
          <div class="row">
            <div class="col-lg-4">
              <div class="reg-membership">
                <div class="heading">
                  <h4>{{sub_packagesdetails[0]?.planname}}</h4>
                  <p> USA Membership </p>
                </div>


                <div class="reg-mbr-year">


                </div>
                <div class="rate">
                  <h1 id="usa_rate">${{sub_packagesdetails[0]?.usa}}</h1>
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" value="usa" id="flexCheckDefault" name="Usaplan"
                      formControlName="checkusa" (change)="click_usa()" />
                    <label class="form-check-label" for="flexCheckDefault">
                    </label>
                  </div>
                  <p>Select Here</p>
                </div>
              </div>
              <div class="donation">
                <select class="form-select fullsize mb-3" aria-label="" formControlName="donationusa">
                  <option [ngValue]="null" [disabled]="true" [selected]='true'>Donation</option>
                  <option value="0">$0</option>
                  <option value="10">$10</option>
                  <option value="25">$25</option>
                  <option value="50">$50</option>
                  <option value="100">$100</option>
                </select>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="reg-membership">
                <div class="heading">
                  <h4>{{sub_packagesdetails[0]?.planname}}</h4>
                  <p> Canada / Mexico Membership</p>
                </div>

                <div class="rate">
                  <h1 class="" id="canada_rate">${{sub_packagesdetails[0]?.canada}}</h1>
                  <div class="form-check">
                    <input class="form-check-input" type="checkbox" value="canada" id="flexCheckDefault"
                      name="Canadaplan" (change)="click_canada()" formControlName="checkcanada" />
                    <label class="form-check-label" for="flexCheckDefault">
                    </label>
                  </div>
                  <p>Select Here</p>
                </div>
              </div>
              <div class="donation">
                <select class="form-select fullsize mb-3" aria-label="" formControlName="donationcanada">
                  <option [ngValue]="null" [disabled]="true" [selected]='true'>Donation</option>
                  <option value="0">$0</option>
                  <option value="10">$10</option>
                  <option value="25">$25</option>
                  <option value="50">$50</option>
                  <option value="100">$100</option>
                </select>
              </div>
            </div>
            <div class="col-lg-4">
              <div class="reg-membership">
                <div class="heading">
                  <h4>{{sub_packagesdetails[0]?.planname}}</h4>
                  <p> Rest of World</p>
                </div>

                <div class="rate">
                  <h1 class="rates" id="rest_rate">${{sub_packagesdetails[0]?.other}}</h1>

                  <div class="form-check">

                    <input class="form-check-input" type="checkbox" value="other" id="flexCheckDefault" name="Otherplan"
                      (change)="click_other()" formControlName="checkother" required />
                    <br>


                  </div>
                  <p>Select Here</p>
                </div>
              </div>
              <div class="donation">
                <select class="form-select fullsize mb-3" aria-label="" formControlName="donationother">
                  <option [ngValue]="null" [disabled]="true" [selected]='true'>Donation</option>
                  <option value="0">$0</option>
                  <option value="10">$10</option>
                  <option value="25">$25</option>
                  <option value="50">$50</option>
                  <option value="100">$100</option>
                </select>
              </div>
            </div>


          </div>
        </div>
        <div class="col-lg-4">
          <div class="reg-form">


            <div class="form-group">
              <input type="text" name="username" class="form-control" placeholder="USER NAME" required
                formControlName="username" />
              <div class="alertbox-err"
                *ngIf="form.get('username').hasError('required') && form.get('username').touched">
                Username Required
              </div>
            </div>

            <div class="form-group">
              <input type="password" class="form-control" name="password" placeholder="PASSWORD"
                formControlName="password" />

              <p class="alertbox-err" *ngIf="form.get('password').hasError('required') && form.get('password').touched">
                Password Required</p>
              <!-- <div class="alertbox-err" *ngIf="passwords.touched && passwords.invalid">
                Password Required
            </div> -->
            </div>
            <div class="form-group">
              <input type="password" name="confrm_password" class="form-control" placeholder="CONFIRM PASSWORD"
                formControlName="confirmPassword" />
              <div class="alertbox-err"
                *ngIf="form.get('confirmPassword').hasError('required') && form.get('confirmPassword').touched">
                Confirm Password Required
              </div>
              <div class="alertbox-err" *ngIf="passwordErr">
                {{passwordErr}}
              </div>

            </div>
          </div>
        </div>
      </div>
      <div class="signup">
        <button (click)="closedev()" class="reg-btn">
          SIGN UP
        </button>
      </div>
    </form>
    <div class="log-direct">
      <p>Already registered? <a [routerLink]="['/login']" [queryParams]="{'Login': 'login'}">Login Here</a></p>
    </div>
    <div class="reg-condition">
      <p>By continuing, you agree to our <a routerLink="/privacy" target="_blank"> Terms & Conditions </a></p>
    </div>
  </div>
</div>